import React from "react";
import {isEmpty} from "../helpers/helpers";
import CircleLoading from "../molecules/lotties/circle_loading";

function ButtonBase(props) {
    const classes = handleButtonClass(props);
    const {onClick, children, disabled, loadingbar, loadingbarText} = props;

    return (
        <button
			name={props.name ?? ''}
            type={props.type ?? 'button'}
            ref={props.buttonRef}
            id={props.id}
            className={classes}
            onClick={onClick}
            disabled={((disabled || loadingbar) ? 'disabled' : '')}
            aria-label={props.ariaLabel ?? 'center'}
        >
            {
                (loadingbar) ?
                    <React.Fragment>
                        <CircleLoading width={24} height={24}/>
                        {
                            (!isEmpty(loadingbarText)) ?
                                <span className="mr-8">{loadingbarText}</span>
                                : ''
                        }
                    </React.Fragment>
                    :
                    children
            }
        </button>
    );
}

export default React.memo(ButtonBase);

// export default ButtonBase;

export function handleButtonClass({variant, size, color, block, className, circle}) {
    let classes = 'btn ';
    if (typeof color == "undefined") {
        color = 'primary';
    }

    if (typeof variant != "undefined" && (variant === 'outline' || variant === 'text')) {
        classes += 'btn-' + variant + '-' + color;
    } else {
        classes += 'btn-' + color;
    }

    if (typeof size != "undefined") {
        classes += ' btn-' + size;
    }

    if (typeof block != "undefined" && block) {
        classes += ' btn-block';
    }

    if (typeof circle != "undefined" && circle) {
        classes += ' btn-circle';
    }

    if (typeof className != "undefined") {
        classes += ' ' + className;
    }
    return classes;
}

// styles